import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute, UrlSegment } from "@angular/router";
import { NotificationService } from "app/main/shared/notification.service";
import { AuthenticationService } from "app/services/authentication.service";
import { Common } from "./../../../utility/common";
import { encryptStorage } from 'environments/environment';
import { ForgetPasswordService } from "./forget-password.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-forget-password",
  templateUrl: "./forget-password.component.html",
  styleUrls: ["./forget-password.component.scss"],
})
export class ForgetPasswordComponent implements OnInit {
  forgetPasswordForm: any;
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(
    private authenticationService: AuthenticationService,
    private forgetPasswordService:ForgetPasswordService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private notify: NotificationService,
    private notifyService: NotificationService
  ) {
    // // this.router.routeReuseStrategy.shouldReuseRoute = function () {
    // //   return false;
    // };
  }

  configerLoginDetails() {
    this.forgetPasswordForm = this.formBuilder.group({
      email: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
    });
  }

  get f() {
    return this.forgetPasswordForm.controls;
  }

  ngOnInit(): void {
    Common.hideloader();
    this.configerLoginDetails();
    console.log("0", this.router);
  }

  onSubmit() {
    //this.submitted = true;
    // stop here if form is invalid
    if (this.forgetPasswordForm.invalid) {
      this.notify.showError("Email is Required", "Error");
      return;
    } 
    else 
    {
      this.authenticationService
        .reset(this.forgetPasswordForm.value)
        .pipe()
        .subscribe((res) => {
          if (res == null)
          {
            this.notifyService.showWarning("Please enter registered email Id", "");
            // this.router.navigate(['/auth/forget-password']);
            console.log("1", this.router);
          } else {
            this.notify.showInfo(
              " If " +
                this.forgetPasswordForm.value.email +
                " is associated with us, you should receive a password reset link in email. Please check your mailbox.",
              "Info"
            );
          }
        });
//       this.ForgetPassword();
    }
  }

  // public ForgetPassword() {
  //     this.authenticationService
  //       .reset(this.forgetPasswordForm.value)
  //       .pipe()
  //       .subscribe((res) => {
  //         if (res.data[0] != undefined) {
           
  //         } else {
  //         }
  //       });

  // }
}
